import type { NotificationOutput } from "@orsane/schema/notifications";

export function getNotificationSearchParams(notification: NotificationOutput) {
    let tab: string | undefined;
    switch (notification.type) {
        case "task_assigned":
        case "task_completed":
            tab = "description";
            break;
        case "task_commented":
        case "task_comment_mentioned":
        case "task_comment_replied":
            tab = "activity";
            break;
    }

    if (notification.taskId) {
        return { task: notification.taskId, taskList: undefined, notification: notification.id, tab };
    }
    if (notification.taskListId) {
        return { task: undefined, taskList: notification.taskListId, notification: notification.id, tab };
    }
    return { task: undefined, taskList: undefined, notification: notification.id, tab: undefined };
}
